<template>
  <div class="container">
    <div class="selectconditons">
      <div class="margin-content">
        <span class="flex-no-warp">手机:</span>
        <a-input
          ref="phoneInput"
          class="width-200-p"
          v-model="inputGroup.phoneInput"
          placeholder="手机号"
          @pressEnter=";(pagination.current = 1), getTableDateNew()"
        >
          <a-icon slot="prefix" type="mobile" />
          <a-tooltip slot="suffix" title="要查询手机号">
            <a-icon type="info-circle" style="color: rgba(0, 0, 0, 0.45)" />
          </a-tooltip>
        </a-input>
      </div>
      <div class="margin-content">
        <span class="flex-no-warp">类型:</span>
        <a-select
          show-search
          @select="chooseWhat"
          @focus="getMessageTypeOpenion()"
          class="width-150-p"
          placeholder="短信类型"
        >
          <a-select-option :value="value" v-for="value in messageType" :key="value">{{ value }}</a-select-option>
        </a-select>
      </div>
      <div class="margin-content">
        <span class="flex-no-warp">来源：</span>
        <a-select class="width-150-p" @select="sourceChooseWhat" show-search placeholder="短信来源">
          <a-select-option v-for="value in sourceOpenion" :key="value.id" :value="value.sources">{{
            value.sources
          }}</a-select-option>
        </a-select>
      </div>
      <div class="margin-content">
        <span class="flex-no-warp">模板号:</span>
        <a-input
          class="width-200-p"
          ref="contentsInput"
          v-model="inputGroup.systemSource"
          placeholder="短信内容"
          @pressEnter=";(pagination.current = 1), getTableDateNew()"
        >
          <a-icon slot="prefix" type="pushpin" />
          <a-tooltip slot="suffix" title="根据模板好查询">
            <a-icon type="info-circle" style="color: rgba(0, 0, 0, 0.45)" />
          </a-tooltip>
        </a-input>
      </div>
      <div class="margin-content">
        <span class="flex-no-warp">内容:</span>
        <a-input
          class="width-200-p"
          ref="contentsInput"
          v-model="inputGroup.contentsInput"
          placeholder="短信内容"
          @pressEnter=";(pagination.current = 1), getTableDateNew()"
        >
          <a-icon slot="prefix" type="pushpin" />
          <a-tooltip slot="suffix" title="根据短信内容模糊查询">
            <a-icon type="info-circle" style="color: rgba(0, 0, 0, 0.45)" />
          </a-tooltip>
        </a-input>
      </div>
      <div class="margin-content">
        <span class="flex-no-warp">结果:</span>
        <a-select class="width-150-p" @select="chooseresultFlag" placeholder="全部">
          <a-select-option v-for="(value, index) in resultType" :key="index" :value="value">{{
            value
          }}</a-select-option>
        </a-select>
      </div>
      <div class="margin-content">
        <span class="flex-no-warp">供应商:</span>
        <a-select @select="choosecmSourceType" class="width-150-p" placeholder="全部">
          <a-select-option :key="2" value="">全部</a-select-option>
          <a-select-option :key="0" value="0">集微</a-select-option>
          <a-select-option :key="1" value="1">cm</a-select-option>
        </a-select>
      </div>
      <div class="margin-content">
        <span class="flex-no-warp">时间:</span>
        <a-range-picker @change="getNewDate" :default-value="defaultDate" class="width-timerpick" />
      </div>
      <a-button class="width-btn" type="primary" icon="search" @click=";(pagination.current = 1), getTableDateNew()"
        >搜索</a-button
      >
      <a-button class="width-btn" type="primary" icon="file-excel" @click="showExprotSetting = true"
        >导出Excel</a-button
      >
    </div>
    <div class="selectresulttable">
      <a-table :columns="columns" :data-source="data" :pagination="false" :loading="loading" bordered  :scroll="{x:true}" ></a-table>
      <div class="pageBar">
        <a-pagination
          style="margin-top: 1%; float: right"
          size="small"
          :current="pagination.current"
          :total="pagination.total"
          :show-total="(total, range) => `${range[0]}-${range[1]} 共 ${total} 条`"
          show-size-changer
          show-quick-jumper
          :showSizeChanger="true"
          :pageSize="pagination.pageSize"
          :pageSizeOptions="pagination.pageSizeOptions"
          @change="onChange"
          @showSizeChange="showSizeChange"
        />
      </div>
    </div>
    <a-modal v-model="showExprotSetting" title="要导出的短信记录" @ok="doExportExcel">
      <a-spin :spinning="exproting" tip="导出中……">
        <div class="exprotSettingOne">
          <a-row>
            <a-col :span="10"> <span>请选择要导出的时间区间：</span></a-col>
            <a-col :span="14"> <a-range-picker @change="getNewExprotDate" :default-value="exprotDefaultDate" /></a-col>
          </a-row>
        </div>
        <div class="exprotSettingTwo">
          <a-row>
            <a-col :span="10"> <span>请选择要导出的模板：</span></a-col>
            <a-col :span="14">
              <a-select show-search placeholder="模板号" style="width: 100%" @select="chooseTemplateCode">
                <a-select-option
                  v-for="(templateItem, index) in templateList"
                  :key="index"
                  :value="templateItem.tempCode"
                >
                  <a-tag color="orange">
                    {{ templateItem.tempCode }}
                  </a-tag>
                  <a-tag color="blue">
                    {{ templateItem.tempName }}
                  </a-tag>
                </a-select-option>
              </a-select>
            </a-col>
          </a-row>
        </div>
        <div class="exprotTemplate">
          <a-row>
            <a-col :span="10"> 模板内容： </a-col>
            <a-col :span="14">
              <a-textarea
                placeholder="要导出的模板内容"
                :autosize="{ minRows: 3, maxRows: 5 }"
                disabled
                v-model="templateContent"
              />
            </a-col>
          </a-row>
        </div>
      </a-spin>
    </a-modal>
  </div>
</template>


<script>
import { getSmsRecord, getMessageType, getSourcesSelecetOpion, getUserCanReadTemplate } from '@/api/api'
import { downFile } from '@/api/manage'
import moment from 'moment'
//表格字段名称
const columns = [
  {
    title: '电话',
    dataIndex: 'phone',
    key: 'phone',
    width: 160,
    align: 'center',
  },
  {
    title: '短信内容',
    dataIndex: 'message',
    key: 'message',
    width: 550,
  },
  {
    title: '信息类型',
    dataIndex: 'type',
    key: 'type',
    width: 100,
    align: 'center',
  },
  {
    title: '消息源',
    dataIndex: 'sources',
    key: 'sources',
    width: 100,
    align: 'center',
  },
  {
    title: '模板名',
    dataIndex: 'tempName',
    key: 'tempName',
    width: 120,
    align: 'center',
  },
  {
    title: '供应商',
    dataIndex: 'cmSourceType',
    key: 'cmSourceType',
    width: 120,
    align: 'center',
    customRender(text) {
      if (text == '1') {
        return 'cm'
      }
      return '集微'
    },
  },
  {
    title: '组ID',
    dataIndex: 'cmGroupId',
    key: 'cmGroupId',
    width: 120,
    ellipsis: true,
  },
  {
    title: '请求结果',
    dataIndex: 'codeStatus_dictText',
    key: 'codeStatus_dictText',
    width: 90,
    align: 'center',
  },
  {
    title: '短信发送结果',
    dataIndex: 'cmSendResult',
    key: 'cmSendResult',
    width: 140,
    align: 'center',
  },
  {
    title: '发送时间',
    dataIndex: 'createTime',
    key: 'createTime',
    width: 120,
  },
]

export default {
  data() {
    return {
      columns,
      data: [],
      //页码数据
      pagination: {
        current: 1,
        total: 0,
        pageSizeOptions: ['5', '10', '15', '20'],
        pageSize: 10,
      },
      //查询参数
      inputGroup: {
        phoneInput: '',
        typeInput: '',
        sourcesInput: '请选择短信来源',
        contentsInput: '',
        resultFlag: '全部',
        systemSource:"",
        cmSourceType: null,
      },
      loading: false,
      dateFormat: 'YYYY-MM-DD',
      endDay: '',
      startDay: '',
      exportStartDay: '',
      exportEndDay: '',
      exportTemplateCode: '',
      //日期
      defaultDate: [
        moment(moment(new Date()).subtract(3, 'day').format('YYYY-MM-DD'), this.dateFormat),
        moment(moment(new Date()).format('YYYY-MM-DD'), this.dateFormat),
      ],
      exprotDefaultDate: [
        moment(moment(new Date()).subtract(1, 'month').format('YYYY-MM-DD'), this.dateFormat),
        moment(moment(new Date()).format('YYYY-MM-DD'), this.dateFormat),
      ],
      messageType: [],
      //短信来源选择器数组
      sourceOpenion: [],
      //结果选项
      resultType: ['全部', '成功', '等待报告', '失败'],
      showExprotSetting: false,
      exproting: false,
      //用户可见模板列表
      templateList: [],
      templateContent: '',
    }
  },
  mounted() {
    //初始化查询日期为近三天
    this.endDay = moment(new Date()).format('YYYY-MM-DD')
    this.startDay = moment(new Date()).subtract(3, 'day').format('YYYY-MM-DD')
    this.exportEndDay = moment(new Date()).format('YYYY-MM-DD')
    this.exportStartDay = moment(new Date()).subtract(1, 'month').format('YYYY-MM-DD')
    //获取列表数据
    this.getTableDate()
    //获取导出选项的信息
    this.getUserCanUseTemplate()
  },
  methods: {
    //获取选择器选项
    getMessageTypeOpenion() {
      getMessageType().then((res) => {
        this.messageType = res.result.value
        this.messageType.splice(0, 0, '全部')
      })
    },
    sourceChooseWhat(key, value) {
      this.inputGroup.sourcesInput = key
      this.pagination.current = 1
      this.getTableDateNew()
    },
    //修改选择器选择的值
    chooseWhat(value) {
      this.inputGroup.typeInput = value
      this.pagination.current = 1
      this.getTableDateNew()
    },
    //修改结果标识选择器
    chooseresultFlag(value) {
      this.inputGroup.resultFlag = value
      this.pagination.current = 1
      this.getTableDateNew()
    },
    //修改结果标识选择器
    choosecmSourceType(value) {
      this.inputGroup.cmSourceType = value
      this.pagination.current = 1
      this.getTableDateNew()
    },
    //页面换页重新获取表格数据
    onChange(page, pageSize) {
      this.pagination.current = page
      this.pagination.pageSize = pageSize
      this.getTableDateNew()
    },
    //页面容量修改时重新获取表格数据
    showSizeChange(current, size) {
      this.pagination.current = current
      this.pagination.pageSize = size
      this.getTableDateNew()
    },
    //日期组件
    moment,
    //获取表格数据
    getTableDate() {
      this.loading = true
      //查询参数  begintime：起始时间  endtime：结束时间 pageNumber：页码 pageSize：页容量 sources：来源 tel：手机号 type：短信类型
      let requestParms = {
        id: this.$ls.get('Login_Userinfo').id,
      }
      getSourcesSelecetOpion(requestParms).then((res) => {
        if (res.success) {
          this.sourceOpenion = res.result
          this.sourceOpenion.splice(0, 0, { id: '000', sources: '全部' })
          this.inputGroup.sourcesInput = this.sourceOpenion[0].sources
          let parms = {
            begintime: this.startDay,
            endtime: this.endDay,
            pageNumber: this.pagination.current,
            pageSize: this.pagination.pageSize,
            contents: this.inputGroup.contentsInput,
            systemSource:this.inputGroup.systemSource,
            sources: this.inputGroup.sourcesInput,
            tel: this.inputGroup.phoneInput,
            type: this.inputGroup.typeInput,
            userid: this.$ls.get('Login_Userinfo').id,
            result: this.inputGroup.resultFlag,
          }
          getSmsRecord(parms).then((res) => {
            if (res.success) {
              this.data = res.result.records
              this.pagination.current = res.result.current
              this.pagination.total = res.result.total
            } else {
              this.$message.error('获取数据失败！')
            }
            this.loading = false
          })
        } else {
          this.$message.error('您没有权限！')
          this.loading = false
        }
      })
    },
    getTableDateNew() {
      this.loading = true
      let parms = {
        begintime: this.startDay,
        endtime: this.endDay,
        pageNumber: this.pagination.current,
        pageSize: this.pagination.pageSize,
        contents: this.inputGroup.contentsInput,
        sources: this.inputGroup.sourcesInput,
        tel: this.inputGroup.phoneInput,
         systemSource:this.inputGroup.systemSource,
        type: this.inputGroup.typeInput,
        userid: this.$ls.get('Login_Userinfo').id,
        result: this.inputGroup.resultFlag,
        cmSourceType: this.inputGroup.cmSourceType,
      }
      getSmsRecord(parms).then((res) => {
        if (res.success) {
          this.data = res.result.records
          this.pagination.current = res.result.current
          this.pagination.total = res.result.total
        } else {
          this.$message.error('获取数据失败！')
        }
        this.loading = false
      })
    },
    //日期修改后重新获取数据
    getNewDate(dates, dateStrings) {
      this.startDay = dateStrings[0]
      this.endDay = dateStrings[1]
      this.getTableDateNew()
    },
    getNewExprotDate(dates, dateStrings) {
      this.exportStartDay = dateStrings[0]
      this.exportEndDay = dateStrings[1]
    },
    chooseTemplateCode(value) {
      this.exportTemplateCode = value
      this.getContent()
    },
    getUserCanUseTemplate() {
      let queryParams = {
        id: this.$ls.get('Login_Userinfo').id,
      }
      getUserCanReadTemplate(queryParams).then((res) => {
        if (res.success) {
          this.templateList = []
          this.templateList = res.result
          console.log(this.templateList)
        } else {
          this.$message.error(res.message)
        }
      })
    },
    getContent() {
      for (var i = 0; i < this.templateList.length; i++) {
        if (this.templateList[i].tempCode == this.exportTemplateCode) {
          this.templateContent = this.templateList[i].contents
          return
        }
      }
    },
    doExportExcel() {
      this.exproting = true
      let parms = {
        templateCode: this.exportTemplateCode,
        endTime: this.exportEndDay,
        startTime: this.exportStartDay,
      }
      let fileName = this.exportStartDay + '到' + this.exportEndDay + '的短信发送记录'
      //使用jeecg封装好的下载js下载xls
      downFile('/goldenHomeMsgMange/exprotSmsRecordExcel', parms).then((data) => {
        console.log(data)
        if (!data) {
          this.$message.warning('文件下载失败')
          this.exproting = false
          return
        }
        if (typeof window.navigator.msSaveBlob !== 'undefined') {
          window.navigator.msSaveBlob(new Blob([data], { type: 'application/vnd.ms-excel' }), fileName + '.xls')
          this.exproting = false
          this.$message.success('导出成功')
          this.showExprotSetting = false
        } else {
          let url = window.URL.createObjectURL(new Blob([data], { type: 'application/vnd.ms-excel' }))
          let link = document.createElement('a')
          link.style.display = 'none'
          link.href = url
          link.setAttribute('download', fileName + '.xls')
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link) //下载完成移除元素
          window.URL.revokeObjectURL(url) //释放掉blob对象
          this.exproting = false
          this.$message.success('导出成功')
          this.showExprotSetting = false
        }
      })
    },
  },
}
</script>

<style scoped>
.container {
  background-color: #ffffff;
  height: 100%;
  width: 100%;
}
.selectconditons {
  padding-top: 1%;
  padding-left: 1%;
  width: 100%;
  background-color: #ffffff;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}
.selectresulttable {
  padding: 0.5%;
  background-color: #ffffff;
}
.pageBar {
  width: 100%;
  height: 3rem;
  background-color: #ffffff;
}
.exprotSettingOne {
  height: 100%;
  margin-top: 1%;
}
.exprotSettingTwo {
  height: 100%;
  margin-top: 3%;
}
.exprotTemplate {
  height: 100%;
  margin-top: 3%;
}
.flex-no-warp {
  white-space: nowrap;
  margin: 0px 10px 0px 20px;
}
.width-150-p {
  width: 150px !important;
}
.width-200-p {
  width: 250px !important;
}
.width-timerpick {
  width: 300px !important;
}
.width-btn {
  margin-left: 20px;
}
.margin-content {
  margin-bottom: 10px;
}
</style>
